import axios from 'axios';
import { EmployeeStatusResponse } from 'src/models/employeeStatus';

import { BASE_URL } from './config';
const ENDPOINT = '/api/report/progress';

export function getReportProgress() {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  return apiClient.get<EmployeeStatusResponse>(`${ENDPOINT}`);
}
